/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import React from 'react';
import { Waiting } from '@msdyn365-commerce-modules/utilities';
import { dateFormatByLocale } from '../helper';

const ATPESDMessageComponent: React.FC<any> = ({ quanATP, propMax, trafficLightsResponse, isLoadingAtpResponse, atpResponse, context }) => {
    let estShipDate;
    let atpHighestDate;
    if (
        atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate &&
        context.app.config.dateFormat &&
        context.request.channel?.Currency
    ) {
        estShipDate =
            dateFormatByLocale(
                context.app.config.dateFormat,
                context.request.channel?.Currency,
                atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate
            ) ?? '';
    }
    if (atpResponse?.HighestDate.toString() && context.app.config.dateFormat && context.request.channel?.Currency) {
        atpHighestDate =
            dateFormatByLocale(context.app.config.dateFormat, context.request.channel?.Currency, atpResponse?.HighestDate.toString()) ?? '';
    }
    if (quanATP! >= propMax && trafficLightsResponse?.StatusCode === '500') {
        return (
            <div>
                <p className='ms-buybox__minmax_label_text'>
                    <span className='sr-only'>Information</span>
                    <i className='msi-InfoCircle' aria-hidden='true'></i>
                    On-Hand Quantity Is {propMax} , And Item Is Discontinued For Future.
                </p>
                {isLoadingAtpResponse ? (
                    <Waiting />
                ) : atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate &&
                  atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate !== '0' ? (
                    atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate && (
                        <p className='atp-response'>Estimated Shipping Date : {estShipDate}</p>
                    )
                ) : (
                    <p className='atp-response'>{atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.Message}</p>
                )}
            </div>
        );
    } else if (
        quanATP >= trafficLightsResponse?.Quantity! + trafficLightsResponse?.POQuantity &&
        trafficLightsResponse?.StatusCode === '503'
    ) {
        return (
            <div>
                <p className='ms-buybox__minmax_label_text'>
                    <span className='sr-only'>Information</span>
                    <i className='msi-InfoCircle' aria-hidden='true'></i>
                    On-Hand Quantity Is {trafficLightsResponse?.Quantity! + trafficLightsResponse?.POQuantity!} , And Item Is Discontinued
                    For Future.
                </p>
                {isLoadingAtpResponse ? (
                    <Waiting />
                ) : atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate &&
                  atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate !== '0' ? (
                    atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate && (
                        <p className='atp-response'>Estimated Shipping Date : {estShipDate}</p>
                    )
                ) : (
                    <p className='atp-response'>{atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.Message}</p>
                )}
            </div>
        );
    } else {
        if (isLoadingAtpResponse) {
            return <Waiting />;
        } else {
            if (atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList.length === 1) {
                if (atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.ATPDate !== '0') {
                    return <p className='atp-response'>Estimated Shipping Date : {estShipDate}</p>;
                } else {
                    return <p className='atp-response'>{atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.Message}</p>;
                }
            } else {
                if (atpResponse?.HighestDate !== undefined) {
                    return <p className='atp-response'>Estimated Shipping Date : {atpHighestDate}</p>;
                } else {
                    return <p className='atp-response'>{atpResponse?.ATPLeadTimePropertiesQuantityResponseEntityList[0]?.Message}</p>;
                }
            }
        }
    }
};

export default ATPESDMessageComponent;
